import createReducer from '../createReducer';
import {
  // FETCH_LOCATION_URL,
  // FETCH_LOCATION_URL_SUCCESS,
  // FETCH_LOCATION_URL_FAILURE,
  FETCH_LOCATION_VIEW,
  FETCH_LOCATION_VIEW_SUCCESS,
  FETCH_LOCATION_VIEW_FAILURE,
} from '../../actions/map';
import { LEAVE_GEONAME_MAP_ROUTE } from '../../actions/routes';

const initialState = {
  loading: false,
  // mapUrl: null,
  taxonomy: {
    location: {
      coordinates: [],
    },
  },
  breadCrumbs: [],
  boundingBox: null,
  travelContent: null,
  siblings: [],
  url: '',
};

const handlers = {};

// handlers[FETCH_LOCATION_URL] = state => ({
//   ...state,
//   loading: true,
// });
//
// handlers[FETCH_LOCATION_URL_SUCCESS] = (state, { url }) => ({
//   ...state,
//   loading: false,
//   mapUrl: url,
// });
//
// handlers[FETCH_LOCATION_URL_FAILURE] = (state, { error }) => ({
//   ...state,
//   loading: false,
//   error,
// });

handlers[FETCH_LOCATION_VIEW] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_LOCATION_VIEW_SUCCESS] = (
  state,
  { taxonomy, travelContent, boundingBox, breadCrumbs, siblings, url }
) => ({
  ...state,
  loading: false,
  boundingBox,
  breadCrumbs,
  taxonomy,
  travelContent,
  siblings,
  url,
});

handlers[FETCH_LOCATION_VIEW_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[LEAVE_GEONAME_MAP_ROUTE] = () => initialState;

export default createReducer(handlers, initialState);
